<div
	class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
>
	
	<button
		class="absolute top-4 right-4 text-2xl w-10 h-10 rounded-full flex items-center justify-center"
		(click)="close()"
	>
		✕
	</button>

	
	<button
		*ngIf="currentIndex > 0"
		(click)="prev()"
		class="absolute left-4 w-10 h-10 rounded-full flex items-center justify-center z-10"
	>
		<mat-icon class="ml-1">arrow_back_ios</mat-icon>
	</button>

	<!-- Media Display -->
	<ng-container *ngIf="images[currentIndex]?.video; else imageTemplate">
		<iframe
			*ngIf="safeVideoUrl"
			allow="autoplay *"
			allowfullscreen="true"
			[src]="safeVideoUrl"
			frameborder="0"
			class="h-[90vh] w-full mx-auto transition-all duration-300 rounded-xl"
		></iframe>
	</ng-container>

	<ng-template #imageTemplate>
		<img
			[src]="images[currentIndex]?.image"
			class="max-w-full max-h-[90vh] mx-auto transition-all duration-300 rounded-xl"
		/>
	</ng-template>

	
	<button
		*ngIf="currentIndex < images.length - 1"
		(click)="next()"
		class="absolute right-4 w-10 h-10 rounded-full flex items-center justify-center z-10"
	>
		<mat-icon>arrow_forward_ios</mat-icon>
	</button>
</div>
